import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolume = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 5.5V12.5L9 16L3 12.5L3 5.5L9 2L15 5.5ZM4 6.07422V11.9248L9 14.8418L14 11.9248V6.07422L9 3.1582L4 6.07422Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 5.50001V6.07815L9.25195 9.43175L9 9.57922L8.74805 9.43175L3 6.07815V5.50001L3.49512 5.21094L9 8.42098L14.5039 5.21094L15 5.50001Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 9V15H8.5V9H9.5Z",
			fill: "black"
		})
	]
});
export default SvgVolume;
